//import userimg from "../images/userimg.png"

export const createBroker = (e) => {
  const form = e.target;

  const data = {
    broker_name: form.name.value,
    broker_surname: form.surName.value,
    email: form.email.value,
    phone_number: form.ownPhoneNumber.value,
    work_number: form.workPhoneNumber.value,
    broker_username: form.userName.value,
    broker_password: form.password.value,
    //image: userimg,
  };

  return data;
};
export const createManager = (e) => {
  const form = e.target;

  const data = {
    manager_name: form.name.value,
    manager_surname: form.surName.value,
    email: form.email.value,
    phone_number: form.ownPhoneNumber.value,
    work_number: form.workPhoneNumber.value,
    manager_username: form.userName.value,
    manager_password: form.password.value,
    //image: userimg,
  };

  return data;
};
